import { Injectable } from '@angular/core'
import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { catchError, Observable, of, throwError } from 'rxjs'
import { environment } from '../../../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class YoutubeService {
  private API_KEY = environment.YOUTUBE_API_KEY
  private CHANNEL_ID = 'UCg93XvouVmeVau3DXKKP_4w'
  private YOUTUBE_API_URL = 'https://www.googleapis.com/youtube/v3'

  constructor(private http: HttpClient) {}

  /*
  getVideos(): Observable<any> {
    const url = `${this.YOUTUBE_API_URL}/search?key=${this.API_KEY}&channelId=${this.CHANNEL_ID}&part=snippet,id&order=date&maxResults=10`
    return this.http.get(url)
    .pipe(catchError(this.errorHandler))
  }
  */
  
  readonly url = environment.DOMAIN_URL+'/api/stream/'

  getVideos(): Observable<any>{
    return this.http.get(this.url+'youtube')
    .pipe(catchError(this.errorHandler))
  }

  private errorHandler(error: HttpErrorResponse) {
    console.error('Error loading videos')
    return of({ items: [] })
  }
}
